// Localized display names for catalog categories and subcategories.
//
// The catalog (Mongo) stores names in English only. Translations live in the
// i18n files under `catalog.categories.<slug>` and
// `catalog.subcategories.<subcategory_id>`. These helpers derive the right key
// and fall back to the English catalog name, so any category that is missing a
// translation (or is brand new) still renders instead of showing a raw key.
//
// Pass the i18next `t` from useTranslation(). Accepts whatever shape the caller
// has: a full catalog object ({ slug, category_id, name }), a job's denormalized
// fields ({ category_id, category_name }), etc.

import i18n from "@/i18n";

export function categoryLabel(t, cat = {}) {
  const slug = cat.slug || (cat.category_id || "").replace(/^cat_/, "");
  // Locale-aware fallback: seeded categories are translated via the i18n key;
  // AI-created categories carry a Spanish name (name_es) used when the UI is in
  // Spanish, otherwise the English name.
  const isEs = (i18n.language || "").toLowerCase().startsWith("es");
  const fallback =
    (isEs && cat.name_es) || cat.name || cat.category_name || slug || "";
  if (!slug) return fallback;
  return t(`catalog.categories.${slug}`, { defaultValue: fallback });
}

export function subcategoryLabel(t, sub = {}) {
  const id = sub.subcategory_id || "";
  const fallback = sub.name || sub.subcategory_name || id || "";
  if (!id) return fallback;
  return t(`catalog.subcategories.${id}`, { defaultValue: fallback });
}
